import {useEffect,useRef} from 'react';
export default function useStatusPolling(callback,enabled,scope,initialDelay=5000,maxChecks=24){
 const latest=useRef(callback);latest.current=callback;
 useEffect(()=>{
  if(!enabled||typeof document==='undefined')return;
  let stopped=false,running=false,timer,checks=0,delay=initialDelay;
  const tick=async()=>{
   if(stopped||document.hidden||running||checks>=maxChecks)return;
   running=true;checks++;
   try{await latest.current();delay=Math.min(Math.round(delay*1.2),30000);}catch{delay=Math.min(delay*2,30000);}finally{running=false;}
   if(!stopped&&!document.hidden&&checks<maxChecks)timer=setTimeout(tick,delay);
  };
  const resume=()=>{clearTimeout(timer);if(!document.hidden){checks=0;delay=initialDelay;if(!running)timer=setTimeout(tick,initialDelay);}};
  document.addEventListener('visibilitychange',resume);window.addEventListener('online',resume);resume();
  return()=>{stopped=true;clearTimeout(timer);document.removeEventListener('visibilitychange',resume);window.removeEventListener('online',resume);};
 },[enabled,scope,initialDelay,maxChecks]);
}
